export const risks = ["HIGH", "MEDIUM", "LOW"]
export const rows = ["8", "9", "10", '11', "12", "13", "14", '15', "16"]